module.exports = __webpack_public_path__ + "img/empty-birthday-offer-2.b335d95f.png";